export const PENDING_SAVE_KEY = 'oppfoundry:pending-save';
